import { render, staticRenderFns } from "./TabAppAccess.vue?vue&type=template&id=72e6b818"
import script from "./TabAppAccess.vue?vue&type=script&setup=true&lang=js"
export * from "./TabAppAccess.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports